import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal'
import cl from './Add.module.css'
import Plus from "../../../../assets/Icon/Plus"; 
import { useTranslation } from 'react-i18next';

const AddAgentModal = ({ agentService, defaultAgent }) => {
    const {t} = useTranslation();
    const agentResetData = {
        name: "",
        number: "",
    }

    const [newAgent, setNewAgent] = useState(agentResetData)
    const [isFirstValidated, setIsFirstValidated] = useState(false)
    const [validates, setValidates] = useState({})

    const validateAgent = (agent) => {
        const messages = {};
    
        if (agent.name.length < 2) {
            messages.name = { message: 'მიუთითეთ სათაური', isValid: false };
        }


        if (agent.number.length < 2) {
            messages.name = { message: 'კონტრაქტის ნომერი', isValid: false };
        }

    
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;  
      };

    const reValidate = () => {
        const isValidate = validateAgent(newAgent)
        
    }

    useEffect(() => {
        if (isFirstValidated === true) {
            const isValidate = validateAgent(newAgent)
        }
      }, [newAgent, isFirstValidated]);

    const [isModalOpen, setIsModalOpen] = useState(false);
 
    const saveHandle = () => {
         
        const isValidate = validateAgent(newAgent)

        if (isValidate === true) {
            agentService.add(newAgent)
            setIsModalOpen(false)
        } else {
            setIsFirstValidated(true) 
        } 
        
    };

    const handleAgentChange = async (event) => {
        let val = event.target.value;
        setNewAgent(prevAgent => ({
            ...prevAgent,
            [event.target.name]: val
        })); 
    };

    const openAdd = () => {
        setValidates({})
        setIsModalOpen(true) 
        setIsFirstValidated(false)
        setNewAgent(agentResetData)
    }

    function convertToInt(str) {
        const num = parseInt(str, 10);
        return isNaN(num) ? 0 : num;
    }
 
  
    const handleAgentInt = async (event) => {
        let val = event.target.value;
        
        setNewAgent(prevAgent => ({
            ...prevAgent,
            [event.target.name]: convertToInt(val)
        })); 
    };
  

    const handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const regex = /^[0-9]+$/; // Regular expression to match only numeric characters

        if (!regex.test(keyValue)) {
            event.preventDefault();
        }
    };
  
    return (
        <div>

            <span onClick={() => openAdd()} className={cl.AddBtn}>
                <span className={cl.icon} > <Plus /></span>
                {t('Add')}
            </span>
  
            <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>

                <div className={cl.modalHead} >
                    <h3>
                        <span className={cl.iconHead} > <Plus /></span> {t('Add')}
                    </h3>
                </div>

                <div className={cl.groupInput}> 
                    <label>{t('Name')}</label>
                    <input type="textS" className={validates && validates.name ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="name" 
                        value={newAgent.name} 
                        onChange={handleAgentChange} 
                        autoComplete="off" />
                </div>
                <div className={cl.groupInput}> 
                    <label>{t('ContractNumber')}</label>
                    <input type="textS" className={validates && validates.name ? cl.input + ' ' + cl.errorInput : cl.input}
                        name="number" 
                        value={newAgent.number} 
                        onChange={handleAgentChange} 
                        autoComplete="off" />
                </div>
                  
                  
                <span onClick={saveHandle} className={cl.btnPrimary}>{t('Add')}</span>

            </Modal>
        </div>
    );
};

export default AddAgentModal;